import { Icon } from '@iconify/react';
import { Divider, Stack, Typography, useTheme } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Schema } from '../../../../../../amplify/data/resource';
import EmptyStateText from '../../../../../components/custom/EmptyStateText';
import AgentIcon from '../../../../../components/icons/AgentIcon';
import FileList from './FileList';

// @ts-ignore
type File = Schema['File']['type'];

// @ts-ignore
type User = Schema['User']['type'];

const apiClient = generateClient<Schema>();

const Agent = () => {
  const theme = useTheme();

  const { uuid } = useParams();

  const navigate = useNavigate();

  const [files, setFiles] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFiles = async () => {
      if (!uuid) return;
      setLoading(true);
      try {
        const subscription = apiClient.models.File.observeQuery({
          filter: { userId: { eq: uuid } },
          selectionSet: [
            'id',
            'createdAt',
            'path',
            'date',
            'status',
            'error',
            'type',
            'xmlVersion',
            'executionDate',
            'workEnvironment',
            'fileNumber',
            'sequenceNumber',
            'senderCode',
            'senderIdentifierType',
            'senderId',
            'senderName',
            'senderContactFirstName',
            'senderContactLastName',
            'senderContactPhone',
            'senderContactEmail',
            'senderContactCellular',
            'recipientCode',
            'recipientIdentifierType',
            'recipientId',
            'recipientCreatorIdentifier',
            'userId',
            'user.*',
            'deposits.totalDepositAmount',
            'deposits.employees.employeeId',
          ],
        }).subscribe({
          next: ({ items }: { items: any[] }) => {
            console.log('fetchFiles:next:', items);
            setFiles(items);
            setLoading(false);
          },
          error: (error: any) => {
            console.error('Error fetching clients:', error);
            setLoading(false);
          },
        });

        return () => subscription.unsubscribe();
      } catch (error) {
        console.error('Error during fetchUsers:', error);
        setLoading(false);
      }
    };

    fetchFiles();
  }, [uuid]);

  const [agent, setAgent] = useState<User | null>(null);

  useEffect(() => {
    const fetchAgent = async () => {
      if (uuid) {
        try {
          const response = await apiClient.models.User.get({ id: uuid });
          console.log('user response', response.data);

          setAgent(response.data as User | null);
        } catch (error) {
          console.error('Error fetching file:', error);
        } finally {
        }
      }
    };

    fetchAgent();
  }, [uuid]);

  return (
    <Stack spacing={2.5}>
      <Stack
        justifyContent="space-between"
        alignItems="center"
        direction="row-reverse"
      >
        <Typography
          fontSize="30px"
          fontWeight="700"
          fontFamily={'AlmoniDL'}
          textAlign="right"
        >
          סוכן
        </Typography>
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          sx={{ cursor: 'pointer' }}
          onClick={() => {
            navigate(-1);
          }}
        >
          <Icon icon="lets-icons:refund-back" />
          <Typography>חזרה</Typography>
        </Stack>
      </Stack>
      <Divider
        sx={{
          width: '100%',
          height: '1px',
          backgroundColor: theme.palette.dark.border,
        }}
      />
      <Stack spacing={2}>
        <Stack direction="row-reverse" alignItems="center" spacing={2}>
          <Stack direction="row-reverse" spacing={1} alignItems="center">
            <AgentIcon />
            <Stack>
              <Typography
                fontSize="18px"
                fontWeight="700"
                fontFamily={'AlmoniDL'}
                textAlign="right"
              >
                {agent?.fullName}
              </Typography>
              <Typography
                fontSize="16px"
                fontWeight="700"
                fontFamily={'AlmoniDL'}
                textAlign="right"
              >
                {agent?.agentId}
              </Typography>
            </Stack>
          </Stack>
          <Icon icon="iconamoon:arrow-left-2-bold" width="30px" />
          <Typography fontSize="20px" fontWeight="700" fontFamily={'AlmoniDL'}>
            הסטוריית הוראות תשלום
          </Typography>
        </Stack>
        {files.length > 0 ? (
          <FileList files={files} />
        ) : (
          <EmptyStateText text="אין קבצים" />
        )}
      </Stack>
    </Stack>
  );
};

export default Agent;
